module.exports = __webpack_public_path__ + "assets/bg_aboutus_01.6a6ac7fe.svg";